//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    constants() {
        return {
            driverColumnDefs: [
                ['firstName', true, 'text'],
                ['lastName', true, 'text'],
            ],
            contactPersonColumnDefs: [
                ['name', true, 'text', r => [[r.firstName, r.lastName].filter(v => v).join(' '), r.position], 'big-small'],
                ['contact', true, 'tel|email', r => [r.phone, r.email], 'big-small'],
            ],
            caseColumnDefs: [
                ['from', true, 'text', r => $.formatDate(r.from)],
                ['to', true, 'text', r => $.formatDate(r.to)],
                ['vehicle', true, 'text', r => this.getVehicleCellValue($.findById($.vehicles, r.vehicleRef)), 'big-small'],
            ],
        };
    },

    data() {
        return {
            leftTab: null,
            filterText: '',
            filterFrom: null,
            filterTo: null,
            errors: {
                rsFrom: false,
                rsTo: false,
            },
        };
    },

    watch: {
        leftTab() {
            this.filterText = '';
            this.filterFrom = null;
            this.filterTo = null;
        },
    },

    methods: {
        getVehicleCellValue(vehicle) {
            return [
                [vehicle.make, vehicle.model].filter(x => x).join(' '),
                [vehicle.variant, vehicle.rz || vehicle.vin].filter(x => x).join(' | '),
            ];
        },
        getVehicleColumnDefs(item) {
            return [
                ['name', true, 'text', this.getVehicleCellValue, 'big-small'],
                ['reservationCount', true, 'number', r => $.count($.cases, c => c.vehicleRef === r.id && c.clientRef === item.id && c.contract.generated), null, true, 'center'],
                ['rentalCount', true, 'number', r => $.count($.cases, c => c.vehicleRef === r.id && c.clientRef === item.id && !c.contract.generated), null, true, 'center'],
            ];
        },
        filterByText(item, csvFieldPaths) {
            return $.filterByCsvFieldPaths(item, csvFieldPaths, this.filterText);
        },
        filterByDateRange(from, to) {
            return (
                (!this.filterFrom && !this.filterTo) ? true :
                (this.filterFrom && this.filterTo) ? this.isDateRangesOverlap(this.filterFrom, this.filterTo, from, to) :
                this.isDateInRange(this.filterFrom ?? this.filterTo, from, to)
            );
        },
        isDateInRange(date, from, to) {
            return this.isDateRangesOverlap(date, date, from, to);
        },
        isDateRangesOverlap(from1, to1, from2, to2) {
            return (
                dayjs(from1).isSameOrBefore(to2, 'day') &&
                dayjs(from2).isSameOrBefore(to1, 'day')
            );
        },
        async validateFn(item, editItem) {
            this.errors.rsFrom = false;
            this.errors.rsTo = false;

            // This causes the bounce animation on fields with errors
            // to be triggered again on repeated validation
            await $.delay(0);

            this.errors.rsFrom = (
                (!editItem.rsFrom && editItem.rsTo && 'Chybí počáteční datum')
            );

            this.errors.rsTo = (
                (!editItem.rsTo && editItem.rsFrom && 'Chybí koncové datum') ||
                (dayjs(editItem.rsTo).isBefore(editItem.rsFrom) && 'Koncové datum je před počátečním')
            );

            return !this.errors.rsFrom && !this.errors.rsTo;
        },
    },
};
